import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

const wrapHaptics = async (callback) => {
  if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('Haptics')) {
    try {
      await callback();
    } catch (error) {
      console.error('Haptics error:', error);
    }
  }
};

const hapticsImpactMedium = async () => {
  wrapHaptics(async () => {
    await Haptics.impact({ style: ImpactStyle.Medium });
  });
};

const hapticsImpactLight = async () => {
  wrapHaptics(async () => {
    await Haptics.impact({ style: ImpactStyle.Light });
  });
};

const hapticsVibrate = async () => {
  wrapHaptics(async () => {
    await Haptics.vibrate();
  });
};

const hapticsSelectionStart = async () => {
  wrapHaptics(async () => {
    await Haptics.selectionStart();
  });
};

const hapticsSelectionChanged = async () => {
  wrapHaptics(async () => {
    await Haptics.selectionChanged();
  });
};

const hapticsSelectionEnd = async () => {
  wrapHaptics(async () => {
    await Haptics.selectionEnd();
  });
};

export {
  hapticsImpactMedium,
  hapticsImpactLight,
  hapticsVibrate,
  hapticsSelectionStart,
  hapticsSelectionChanged,
  hapticsSelectionEnd,
};
